module.exports = __webpack_public_path__ + "static/img/lectureFour.f687ea1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lectureFour.png
// module id = GWFz
// module chunks = 1